import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import Landing from "@/pages/Landing";
import PaymentResult from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";
import OfferPage from "@/pages/OfferPage";
import SbloccoPage from "@/pages/SbloccoPage";
import DocumentiPage from "@/pages/DocumentiPage";
import { Toaster } from "sonner";
import MetaPixelRouter from "@/analytics/MetaPixelRouter";

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#FFFFFF] text-[#003087]">
        <BrowserRouter>
          <MetaPixelRouter />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/payment/:result" element={<PaymentResult />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/offerta/:orderId" element={<OfferPage />} />
            <Route path="/sblocca/:orderId" element={<SbloccoPage />} />
            <Route path="/documenti/:orderId" element={<DocumentiPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </LanguageProvider>
  );
}

export default App;
